import {React,useState} from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent, CardMedia, Typography, Button,Menu,MenuItem } from '@mui/material';
import MDButton from "components/MDButton";

import MDBox from "components/MDBox";
import Organization from '..';

const OrganizationCard = ({org ,editformData,deleteOrganization}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const isMenuOpen = Boolean(anchorEl);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  return (
    <Card sx={{  boxShadow: 3 }}>
       <MDBox sx={{ position: 'absolute', top: 8, right: 8 }}>
        <MDButton onClick={handleMenuOpen}>
              I
        </MDButton>
        <Menu
          anchorEl={anchorEl}
          open={isMenuOpen}
          onClose={handleMenuClose}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <MenuItem onClick={() => editformData(org)}>Edit</MenuItem>
          <MenuItem onClick={() => deleteOrganization(org)}>Delete</MenuItem>
        </Menu>
      </MDBox>
      <CardContent>
        <Typography variant="h5" component="div" gutterBottom>
          {org.name}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          <strong>Email:</strong> {org.email}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          <strong>Phone:</strong> {org.number}
        </Typography>
        {org.website && (
          <MDButton
            href={org.website}
            size="small"
            variant="text"
            color="info"
            sx={{ marginTop: 2 }}
            target="_blank"
            rel="noopener noreferrer"
          >
          readmore..
          </MDButton>
        )}
      </CardContent>
    </Card>
  );
};
OrganizationCard.propTypes = {
  org:PropTypes.object.isRequired,
  editformData: PropTypes.func.isRequired,
  deleteOrganization: PropTypes.func.isRequired
};
export default OrganizationCard;
